/* -------------------------------------------------------------------------------------------------
Restricted - Copyright (C) Siemens Healthcare GmbH/Siemens Medical Solutions USA, Inc., 2020. All rights reserved
------------------------------------------------------------------------------------------------- */
import { ArcOverlayMixin } from '@advanced-rest-client/arc-overlay-mixin';
import { css, html, LitElement } from 'lit-element';

export class SHOverlay extends ArcOverlayMixin(LitElement) {
  static get styles() {
    return css`
      :host {
        background: transparent;
      }
    `;
  }

  render() {
    return html` <slot></slot> `;
  }

  firstUpdated() {
    this.addEventListener('closed', (e) => {
      e.stopImmediatePropagation();
    });

    this.addEventListener('opened', (e) => {
      e.stopImmediatePropagation();
    });
  }
}

customElements.define('sh-overlay', SHOverlay);
